import React from "react";
import { Box, Tooltip } from "@mui/material";
import { tokens } from "../../theme";

/**
 * Acción de una fila de tabla. Todas las tablas del sistema usan esta pieza,
 * así el tamaño, el área de click y el color son iguales en todos lados.
 *
 * Color: gris por defecto y rojo al pasar el mouse. El rojo pleno queda
 * reservado para lo destructivo (`tone="danger"`).
 */
const RowAction = ({ icon: Icon, title, onClick, disabled = false, tone = "default" }) => {
  const color = disabled
    ? tokens.ink4
    : tone === "danger"
    ? tokens.brandDark
    : tokens.ink2;

  const content = (
    <Box
      // Botón real: como <div role="button"> no se podía llegar con Tab ni
      // activar con Enter, las acciones de tabla quedaban fuera del teclado.
      component="button"
      type="button"
      aria-label={title}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      sx={{
        width: 32,
        height: 32,
        padding: 0,
        border: "none",
        background: "transparent",
        font: "inherit",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: `${tokens.radiusControl}px`,
        color,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "background-color 120ms ease, color 120ms ease",
        "&:hover": disabled
          ? undefined
          : { backgroundColor: tokens.borderSoft, color: tokens.brandDark },
      }}
    >
      <Icon size={17} />
    </Box>
  );

  return title ? (
    <Tooltip title={title} arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

/** Contenedor de acciones: alineadas a la derecha y con ranuras parejas. */
export const RowActions = ({ children }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: "2px", justifyContent: "flex-end" }}>
    {children}
  </Box>
);

/** Ranura vacía, para que las filas sin una acción no descoloquen al resto. */
export const RowActionSpacer = () => (
  <Box sx={{ width: 32, height: 32, flexShrink: 0 }} aria-hidden="true" />
);

export default RowAction;
